




















































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import coreApiWorkerClient from "@/services/apis/coreApiWorkerClient";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import userManager from "@/services/userManager";
import makeSelectOptions from "@common/util/makeSelectOptions";
import userRoles from "@/constants/userRoles";
import PasswordProtected from "@/components/PasswordProtected.vue";
import SalariesUsers from "./salaries/Users.vue";

function salaryFormulaSetFieldDefs() {
  return {
    workingStartDay: {
      type: "XDateTimePicker",
      attrs: {
        label: "Ngày bắt đầu làm việc",
        xOptions: {
          content: {
            resultFilter: (m) => m.startOf("day"),
          },
        },
      },
    },
    totalWorkingDay: {
      type: "number",
      attrs: {
        label: "Tổng ngày làm việc",
      },
    },
    lunchAllowancePerDay: {
      type: "number",
      attrs: {
        label: "Phụ cấp ăn trưa / ngày",
      },
    },
    returnedSocialInsuranceFee: {
      type: "number",
      attrs: {
        label: "Trả lại BHXH",
      },
    },
    ctBirthdayBonus: {
      type: "number",
      attrs: {
        label: "Thưởng sinh nhật chính thức",
      },
    },
    tvBirthdayBonus: {
      type: "number",
      attrs: {
        label: "Thưởng sinh nhật thử việc",
      },
    },
    baseSalaryFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính lương cứng",
      },
    },
    redLineFineFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính phạt lằn ranh đỏ",
      },
    },
    kpiBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI",
      },
    },
    topKpiBonusCheckFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức check thưởng KPI doanh số người tốt nhất",
      },
    },
    topKpiBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI doanh số người tốt nhất",
      },
    },
    ctUpBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng nhân viên lên chính thức",
      },
    },
    leaderCtUpBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng leader lên chính thức",
      },
    },
    bonusArrearsFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính truy thu thưởng",
      },
    },
    teamKpiBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI team",
      },
    },
    leadKpiBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI lead",
      },
    },
    tvKpiBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI thử việc",
      },
    },
    otherKpiBonusFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI khác",
      },
    },
    leadKpiFineFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính phạt KPI lead",
      },
    },
    leadRedLineFineFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính phạt lằn ranh đỏ của team lead",
      },
    },
    ctKpiFineFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính phạt KPI chính thức + phó nhóm",
      },
    },
    productReturnCheckFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức check return NSP",
      },
    },
    productReturnFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính DSDK return NSP",
      },
    },
    rdProductGroupCheckFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức check test NSP",
      },
    },
    rdProductGroupFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính DSDK test NSP",
      },
    },
    qualityRevenueFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính Doanh số hiệu quả",
      },
    },
    coefficientAFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính hệ số A",
      },
    },
    kpiBonusByRevenueMilestoneFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI theo mốc doanh số",
      },
    },
    optimizedKpiBonusFromRevenueFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI tối ưu từ doanh số",
      },
    },
    optimizedKpiBonusFromAdCostFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính thưởng KPI tối ưu từ CPQC",
      },
    },
    fixedSalaryByKpiFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính lương cứng theo KPI",
      },
    },
    fuelAllowanceFormula: {
      type: "textLarge",
      attrs: {
        label: "Công thức tính hỗ trợ xăng xe",
      },
    },
    userCustomVariableItems: {
      type: "XArrayInput",
      attrs: {
        label: "Tham số tùy biến khi tính toán lương nhân viên",
        xOptions: {
          content: {
            defaultExpandDisabled: true,
            itemLabel: (item, i) => item.name || `Tham số ${i + 1}`,
            itemProperties: {
              name: {
                type: "text",
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              formula: {
                type: "textLarge",
                attrs: {
                  label: "Công thức",
                  required: true,
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
            },
            template: {
              formOptions: {
                content: {
                  colLength: 12,
                },
              },
            },
          },
        },
      },
    },
  };
}

export default Vue.extend({
  components: {
    PasswordProtected,
    SalariesUsers: SalariesUsers as any,
  },
  data() {
    return {
      self: this,
      userManager,
      month: parseInt(this.$route.params.month, 10),
      currentTab: "",
      currentSubTab: "",
      tabs: {} as Record<string, any>,
      subTabs: {} as Record<string, any>,
      departments: [] as any[],
      item: {},
      refreshing: true,
      monthPickerOptions: {
        attrs: {
          label: "Chọn tháng",
        },
        content: {
          dpAttrs: {
            type: "month",
          },
          menuAttrs: {
            // "auto" breaks Vuetify's menu overflow-correction math (NaN width),
            // letting the popover run off the right edge in this right-aligned toolbar.
            minWidth: undefined,
          },
          format: "YYYY-MM",
          setDefaultValue: true,
        },
      },
      itemEditBtnOptions: {
        attrs: {
          small: true,
          color: "primary",
          dark: true,
          class: "ml-2 mb-4",
        },
        content: {
          icon: "mdi-cog-outline",
          text: "Cài đặt tháng",
        },
        target: {
          tooltip: {
            content: {
              text: "Setting",
            },
          },
          dialog: {
            attrs: {
              width: "800px",
            },
            handlers: {
              initialize() {
                this.options.content.buttons.save.states.enabled = new DataContainer(false);
              },
            },
            content: {
              toolbar: {
                title: "Cài đặt tháng",
              },
              content: {
                type: "XForm",
                makeAttrs(attrs: any = {}, dialog) {
                  const { item } = dialog.context().context();
                  attrs.xOptions = {
                    content: {
                      sections: {
                        teamKpi: {
                          header: "Tham số & công thức (team kpi)",
                          fields: {
                            teamKpiFormula: {
                              type: "textLarge",
                              attrs: {
                                label: "Công thức tính KPI team",
                              },
                            },
                            teamBonus: {
                              type: "number",
                              attrs: {
                                label: "Thưởng team",
                              },
                            },
                            teamQualityRevenueFormula: {
                              type: "textLarge",
                              attrs: {
                                label: "Công thức tính doanh số hiệu quả team",
                              },
                            },
                            teamMinimumQualityRevenueFormula: {
                              type: "textLarge",
                              attrs: {
                                label: "Công thức tính doanh số hiệu quả tối thiểu team",
                              },
                            },
                            teamQualityRevenuePerUserThreshold: {
                              type: "number",
                              attrs: {
                                label: "Ngưỡng doanh số hiệu quả team / người",
                              },
                            },
                            teamCustomVariableItems: {
                              type: "XArrayInput",
                              attrs: {
                                label: "Tham số tùy biến khi tính toán Team KPI",
                                xOptions: {
                                  content: {
                                    defaultExpandDisabled: true,
                                    itemLabel: (item, i) => item.name || `Tham số ${i + 1}`,
                                    itemProperties: {
                                      name: {
                                        type: "text",
                                        attrs: {
                                          label: "Tên",
                                          required: true,
                                        },
                                      },
                                      formula: {
                                        type: "textLarge",
                                        attrs: {
                                          label: "Công thức",
                                          required: true,
                                        },
                                      },
                                      description: {
                                        type: "textLarge",
                                        attrs: {
                                          label: "Mô tả",
                                        },
                                      },
                                    },
                                    template: {
                                      formOptions: {
                                        content: {
                                          colLength: 12,
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            },
                            teamKpiFormulaSets: {
                              type: "XArrayInput",
                              attrs: {
                                label: "Công thức KPI team theo phòng / team",
                                xOptions: {
                                  content: {
                                    defaultExpandDisabled: true,
                                    itemLabel: (item, i) => item.name || `Bộ công thức ${i + 1}`,
                                    itemProperties: {
                                      name: {
                                        type: "text",
                                        attrs: {
                                          label: "Tên",
                                          required: true,
                                        },
                                      },
                                      departmentIds: {
                                        type: "XAutocomplete",
                                        attrs: {
                                          label: "Phòng áp dụng (áp dụng cho toàn bộ team thuộc phòng)",
                                          "item-value": "_id",
                                          "item-text": "name",
                                          multiple: true,
                                          xOptions: {
                                            content: {
                                              async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call("departments", "findAll", {
                                                  payload: JSON.stringify({
                                                    limit,
                                                    search,
                                                    filters: [
                                                      {
                                                        key: "_id",
                                                        operator: "in",
                                                        value,
                                                      },
                                                    ],
                                                  }),
                                                });
                                                return items;
                                              },
                                            },
                                          },
                                        },
                                      },
                                      teamIds: {
                                        type: "XAutocomplete",
                                        attrs: {
                                          label: "Team áp dụng (ưu tiên cao hơn Phòng áp dụng khi cùng khớp)",
                                          "item-value": "_id",
                                          "item-text": "name",
                                          multiple: true,
                                          xOptions: {
                                            content: {
                                              async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call("teams", "findAll", {
                                                  payload: JSON.stringify({
                                                    limit,
                                                    search,
                                                    filters: [
                                                      {
                                                        key: "_id",
                                                        operator: "in",
                                                        value,
                                                      },
                                                    ],
                                                  }),
                                                });
                                                return items;
                                              },
                                            },
                                          },
                                        },
                                      },
                                      priority: {
                                        type: "number",
                                        attrs: {
                                          label: "Độ ưu tiên (khi có nhiều bộ cùng khớp phòng)",
                                        },
                                      },
                                      teamKpiFormula: {
                                        type: "textLarge",
                                        attrs: {
                                          label: "Công thức tính KPI team",
                                        },
                                      },
                                      teamBonus: {
                                        type: "number",
                                        attrs: {
                                          label: "Thưởng team",
                                        },
                                      },
                                      teamQualityRevenueFormula: {
                                        type: "textLarge",
                                        attrs: {
                                          label: "Công thức tính doanh số hiệu quả team",
                                        },
                                      },
                                      teamMinimumQualityRevenueFormula: {
                                        type: "textLarge",
                                        attrs: {
                                          label: "Công thức tính doanh số hiệu quả tối thiểu team",
                                        },
                                      },
                                      teamQualityRevenuePerUserThreshold: {
                                        type: "number",
                                        attrs: {
                                          label: "Ngưỡng doanh số hiệu quả team / người",
                                        },
                                      },
                                      teamCustomVariableItems: {
                                        type: "XArrayInput",
                                        attrs: {
                                          label: "Tham số tùy biến khi tính toán Team KPI",
                                          xOptions: {
                                            content: {
                                              defaultExpandDisabled: true,
                                              itemLabel: (item, i) => item.name || `Tham số ${i + 1}`,
                                              itemProperties: {
                                                name: {
                                                  type: "text",
                                                  attrs: {
                                                    label: "Tên",
                                                    required: true,
                                                  },
                                                },
                                                formula: {
                                                  type: "textLarge",
                                                  attrs: {
                                                    label: "Công thức",
                                                    required: true,
                                                  },
                                                },
                                                description: {
                                                  type: "textLarge",
                                                  attrs: {
                                                    label: "Mô tả",
                                                  },
                                                },
                                              },
                                              template: {
                                                formOptions: {
                                                  content: {
                                                    colLength: 12,
                                                  },
                                                },
                                              },
                                            },
                                          },
                                        },
                                      },
                                    },
                                    template: {
                                      formOptions: {
                                        content: {
                                          colLength: 12,
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                        userSalary: {
                          header: "Tham số & công thức (lương user)",
                          fields: {
                            ...salaryFormulaSetFieldDefs(),
                            manualOverrideTeamIds: {
                              type: "XAutocomplete",
                              attrs: {
                                label:
                                  "Team giữ nguyên giá trị nhập tay, không tự tính lại theo công thức (hiện áp dụng cho Thưởng KPI khác)",
                                "item-value": "_id",
                                "item-text": "name",
                                multiple: true,
                                xOptions: {
                                  content: {
                                    async itemsSuggestor(search, value, limit) {
                                      const { items } = await coreApiClient.call("teams", "findAll", {
                                        payload: JSON.stringify({
                                          limit,
                                          search,
                                          filters: [
                                            {
                                              key: "_id",
                                              operator: "in",
                                              value,
                                            },
                                          ],
                                        }),
                                      });
                                      return items;
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                        formulaSets: {
                          header: "Bảng lương theo bộ phận",
                          fields: {
                            formulaSets: {
                              type: "XArrayInput",
                              attrs: {
                                label: "Các bộ công thức theo bộ phận",
                                xOptions: {
                                  content: {
                                    defaultExpandDisabled: true,
                                    itemLabel: (item, i) => item.name || `Bộ công thức ${i + 1}`,
                                    itemProperties: {
                                      name: {
                                        type: "text",
                                        attrs: {
                                          label: "Tên",
                                          required: true,
                                        },
                                      },
                                      roles: {
                                        type: "selectMultiple",
                                        attrs: {
                                          label: "Vai trò (để trống = mọi vai trò)",
                                          items: makeSelectOptions(userRoles),
                                        },
                                      },
                                      mktPlatformIds: {
                                        type: "XAutocomplete",
                                        attrs: {
                                          label: "Nền tảng MKT (để trống = mọi nền tảng)",
                                          "item-value": "_id",
                                          "item-text": "name",
                                          multiple: true,
                                          xOptions: {
                                            content: {
                                              async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call("mktPlatforms", "findAll", {
                                                  payload: JSON.stringify({
                                                    limit,
                                                    search,
                                                    filters: [
                                                      {
                                                        key: "_id",
                                                        operator: "in",
                                                        value,
                                                      },
                                                    ],
                                                  }),
                                                });
                                                return items;
                                              },
                                            },
                                          },
                                        },
                                      },
                                      userIds: {
                                        type: "XAutocomplete",
                                        attrs: {
                                          label: "Nhân viên cụ thể (để trống = mọi nhân viên)",
                                          "item-value": "_id",
                                          "item-text": "name",
                                          multiple: true,
                                          xOptions: {
                                            content: {
                                              async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call("users", "findAll", {
                                                  payload: JSON.stringify({
                                                    limit,
                                                    search,
                                                    filters: [
                                                      {
                                                        key: "_id",
                                                        operator: "in",
                                                        value,
                                                      },
                                                    ],
                                                  }),
                                                });
                                                return items;
                                              },
                                            },
                                          },
                                        },
                                      },
                                      priority: {
                                        type: "number",
                                        attrs: {
                                          label: "Độ ưu tiên (khi có nhiều bộ cùng khớp mức độ cụ thể)",
                                        },
                                      },
                                      ...salaryFormulaSetFieldDefs(),
                                    },
                                    template: {
                                      formOptions: {
                                        content: {
                                          colLength: 12,
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              content: {
                                rules: {
                                  custom: [
                                    async (value) => {
                                      const items = value || [];
                                      for (const item of items) {
                                        if (!(item.roles || []).length && !(item.mktPlatformIds || []).length && !(item.userIds || []).length) {
                                          return `Bộ công thức "${item.name || ""}" phải khai báo ít nhất 1 trong 3: vai trò, nền tảng MKT, hoặc nhân viên cụ thể`;
                                        }
                                      }
                                      return true;
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        calculate: {
                          header: "Tính toán",
                          fields: {
                            committedDataTime: {
                              type: "XTimePicker",
                              attrs: {
                                label: "Thời gian chốt dữ liệu",
                                xOptions: {
                                  content: {
                                    textFieldAttrs: {
                                      readonly: true,
                                      disabled: true,
                                    },
                                  },
                                },
                              },
                            },
                            commitData: {
                              type: "boolean",
                              attrs: {
                                label: "Chốt dữ liệu",
                              },
                            },
                            commitDataPartial: {
                              type: "boolean",
                              attrs: {
                                label: "Chốt dữ liệu (partial)",
                              },
                              ext: {
                                condition(self) {
                                  return true || self.getData().commitData;
                                },
                              },
                            },
                            recalculate: {
                              type: "boolean",
                              attrs: {
                                label: "Tính lại lương",
                              },
                              ext: {
                                condition() {
                                  return item.committedDataTime;
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  };
                  attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                  attrs.xContext = dialog;
                  attrs.xData = new DataContainer(item);
                  return attrs;
                },
              },
              buttons: {
                save: {
                  content: {
                    text: "Cập nhật",
                  },
                  states: {},
                  on: {
                    async xClick({ self }) {
                      const dialog = self.context();
                      const btn = dialog.context();
                      const { month } = btn.context();
                      const form = dialog.contentContainer.value;
                      const data = form.getData();
                      self.loading.value = true;
                      let result = await coreApiWorkerClient.call(
                        "salaryMonthInfos",
                        "updateByMonth",
                        {
                          month,
                        },
                        {
                          data,
                        }
                      );
                      if (result) {
                        if (data.commitData) {
                          result = await coreApiWorkerClient.call("salaries", "commitData", {
                            month,
                            partial: data.commitDataPartial,
                          });
                        }
                      }
                      if (result) {
                        if (data.recalculate) {
                          result = await coreApiWorkerClient.call("salaries", "calculate", {
                            month,
                          });
                        }
                      }
                      self.loading.value = false;
                      if (result) {
                        location.reload();
                      }
                    },
                  },
                },
              },
            },
          },
        },
      },
    };
  },
  computed: {
    activeSection(): string {
      return this.$route.path.split("/")[4] || "";
    },
    isUsersSection(): boolean {
      return this.activeSection === "users" || this.activeSection === "dept";
    },
    isTp(): boolean {
      return this.userManager.checkRole(["tp"]);
    },
    isTeamLeader(): boolean {
      return this.userManager.getUserInfo()?.ht === "ld";
    },
    canBrowseScopedSalaries(): boolean {
      return this.isTp || this.isTeamLeader;
    },
    nonAdminSalariesTitle(): string {
      if (this.isTp) {
        return "Lương phòng ban";
      }
      if (this.isTeamLeader) {
        return "Lương nhóm";
      }
      return "Lương của tôi";
    },
  },
  watch: {
    month() {
      this.buildTabs();
      if (this.activeSection === "dept" && this.$route.params.departmentId) {
        this.$router.push(`/app/salaries/${this.month}/dept/${this.$route.params.departmentId}`);
        return;
      }
      if (this.activeSection === "users") {
        this.$router.push(`/app/salaries/${this.month}/users`);
        return;
      }
      const activeTab = this.tabs[this.activeSection];
      this.$router.push(activeTab ? activeTab.path : `/app/salaries/${this.month}/summary`);
    },
  },
  methods: {
    async refresh() {
      this.refreshing = true;
      const item = await coreApiWorkerClient.call("salaryMonthInfos", "findByMonth", {
        month: this.month,
      });
      this.item = item || {};
      this.refreshing = false;
    },
    async fetchDepartments() {
      const { items } = await coreApiClient.call("departments", "findAll", {
        payload: JSON.stringify({
          limit: -1,
          filters: [{ key: "disabled", operator: "equal_to", value: false }],
        }),
      });
      this.departments = items || [];
    },
    buildTabs() {
      this.tabs = {
        summary: {
          label: "Tổng",
          path: `/app/salaries/${this.month}/summary`,
        },
        users: {
          label: "Tất cả",
          path: `/app/salaries/${this.month}/users`,
        },
        teams: { label: "Teams", path: `/app/salaries/${this.month}/teams` },
        team_committed_data: { label: "Dữ liệu chốt (Team)", path: `/app/salaries/${this.month}/team_committed_data` },
        user_committed_data: { label: "Dữ liệu chốt (User)", path: `/app/salaries/${this.month}/user_committed_data` },
        params: { label: "Tài liệu", path: `/app/salaries/${this.month}/params` },
      };
      const subTabs: Record<string, any> = {
        all: {
          label: "Tất cả",
          path: `/app/salaries/${this.month}/users`,
        },
      };
      for (const department of this.departments) {
        subTabs[`dept_${department._id}`] = {
          label: department.name,
          path: `/app/salaries/${this.month}/dept/${department._id}`,
        };
      }
      this.subTabs = subTabs;
    },
  },
  created() {
    if (this.userManager.checkRole(["admin", "kt"])) {
      this.refresh();
      this.fetchDepartments().then(() => this.buildTabs());
    }
  },
});
